import { Component } from '@angular/core';
import { IconComponent } from '../../controls/icons/icon/icon.component';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    imports: [IconComponent],
})
export class UnauthorizedComponent {}
